<div [ngClass]="{'sidebar-active': app.sidebarActive}" class="flex">
    <!-- width: calc(100vw - 410px);  -->
    <div class="sidebar-next-right-block" style="width: 100%;">
        <home-driver-training *ngIf="activeMenu === menuEnum.DriverTraining"></home-driver-training>
        <home-disciplinary *ngIf="activeMenu === menuEnum.Disciplinary"></home-disciplinary>
        <home-driver-centers *ngIf="activeMenu === menuEnum.DriverCenters"></home-driver-centers>
        <drivers *ngIf="activeMenu === menuEnum.Drivers"></drivers>
        <home-customers *ngIf="activeMenu === menuEnum.Users"></home-customers>
        <home-transactions *ngIf="activeMenu === menuEnum.Transactions"></home-transactions>
        <home-accounting *ngIf="activeMenu === menuEnum.Accounting"></home-accounting>
        <home-settings *ngIf="activeMenu === menuEnum.Settings"></home-settings>
        <onboarding-vehicles *ngIf="activeMenu === menuEnum.ExcistingDriversVehicles"></onboarding-vehicles>
        <home-calendar *ngIf="activeMenu === menuEnum.Calendar"></home-calendar>
        <mart-onboarding [_menuHomeEnumActive]="activeMenu"
                         *ngIf="activeMenu === menuEnum.MartOnboarding || activeMenu === menuEnum.FoodOnboarding">
        </mart-onboarding>
    </div>
</div>
